module.exports = __webpack_public_path__ + "static/mirage@2x-f6d085f775e3c0159cbf0498cab10d48.gif";